import create from 'zustand'
import { formatDate, subtractDays } from '../../utils/helpers'
import { getDateComparer } from '../../utils/helpers'

export const useStore = create((set) => {
  const today = new Date()
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const startDate = getDateComparer(today, 0)

  const previousEndDate = subtractDays(startDate, 1)
  const previousStartDate = getDateComparer(previousEndDate, 0)
  
  return ({
    adminItem: '/',
    timezone,
    kpiTimeSpan: 0,
    kpiStartDate: startDate,
    kpiEndDate: today,
    kpiPreviousStartDate: previousStartDate,
    kpiPreviousEndDate: previousEndDate,
    kpiDateRange: `${formatDate(startDate)} - ${formatDate(today)}`,
    changeAdminItem: (item) => set((state) => ({
      ...state,
      adminItem: item
    })),
    setKpiTimeSpan: (value) => set((state) => {     
      if (value < 5) {
        const startDate = getDateComparer(today, value)
        
        const previousEndDate = subtractDays(startDate, 1)
        const previousStartDate = getDateComparer(previousEndDate, value)
        return ({
          ...state,
          kpiTimeSpan: value,
          kpiStartDate: startDate,
          kpiEndDate: today,
          kpiPreviousStartDate: previousStartDate,
          kpiPreviousEndDate: previousEndDate,
          kpiDateRange: `${formatDate(startDate)} - ${formatDate(today)}`
        })
      }
      
      return ({
        ...state,
        kpiTimeSpan: value,
      })
    }),
    setKpiDates: ({ startDate, endDate, dateRange }) => set((state) => ({
      ...state,
      kpiStartDate: startDate,
      kpiEndDate: endDate,
      kpiDateRange: dateRange
    }))
  })
})